import { render, staticRenderFns } from "./GetInfo.vue?vue&type=template&id=12840664&scoped=true&"
import script from "./GetInfo.vue?vue&type=script&lang=js&"
export * from "./GetInfo.vue?vue&type=script&lang=js&"
import style0 from "./GetInfo.vue?vue&type=style&index=0&id=12840664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12840664",
  null
  
)

export default component.exports